import { FinancialTool } from "../types";
import { loanTools } from "./tools/loans";
import { savingsTools } from "./tools/savings";
import { retirementTools } from "./tools/retirement";
import { fireAndRetirementNewTools } from "./tools/fireAndRetirementNew";
import { mortgageNewTools } from "./tools/mortgageNew";
import { creditAndInvestmentTools } from "./tools/creditAndInvestment";
import { budgetTools } from "./budget";
import { remainingTools } from "./remaining";
import { insuranceTools } from "./tools/insurance";
import { aiFinanceTools } from "./tools/aiFinance";

// Combine all financial calculators
export const allTools: FinancialTool[] = [
  ...loanTools,
  ...savingsTools,
  ...retirementTools,
  ...fireAndRetirementNewTools,
  ...mortgageNewTools,
  ...creditAndInvestmentTools,
  ...budgetTools,
  ...remainingTools,
  ...insuranceTools,
  ...aiFinanceTools
];

// Slugs translation helper
export function getSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}

// Map slug -> tool for fast O(1) lookups
export const toolsBySlug = allTools.reduce((acc, tool) => {
  const slug = getSlug(tool.name);
  acc[slug] = tool;
  return acc;
}, {} as Record<string, FinancialTool>);
